import Promise from "promise-polyfill";

//re-init on data-src change lazyload bg images
require("../node_modules/lazysizes/plugins/attrchange/ls.attrchange.js");
//unveilhooks required to lazyload bg images
require("../node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js");
import lazysizes from "lazysizes";

if (!window.Promise) {
  window.Promise = Promise;
}

import Vue from "vue";
import App from "./vue/App.js";

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.event = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.event);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.event);
  }
});

Vue.filter("encode", function(str) {
  var buf = [];

  for (var i = str.length - 1; i >= 0; i--) {
    buf.unshift(["&#", str[i].charCodeAt(), ";"].join(""));
  }

  return buf.join("");
});

Vue.filter("decode", function(str) {
  return str.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec);
  });
});

Vue.filter("truncate", function(text, length, clamp) {
  clamp = clamp || "...";
  length = length || 30;

  if (text.length <= length) return text;

  var tcText = text.slice(0, length - clamp.length);
  var last = tcText.length - 1;

  while (last > 0 && tcText[last] !== " " && tcText[last] !== clamp[0])
    last -= 1;

  // Fix for case when text dont have any `space`
  last = last || length - clamp.length;

  tcText = tcText.slice(0, last);

  return tcText + clamp;
});

if (document.getElementById("primary")) {
  new Vue(App);
}

require("./main.js");
